import { render, staticRenderFns } from "./PlaceholderWrapper.vue?vue&type=template&id=50275b9b&scoped=true"
import script from "./PlaceholderWrapper.vue?vue&type=script&lang=js"
export * from "./PlaceholderWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50275b9b",
  null
  
)

export default component.exports